import React, { useEffect, useState } from 'react'
import Cleave from 'cleave.js/react';
import config from '../../../../services/config';

import BoletoService from '../../../../services/boleto-service'
import error from '../autorizacaoGuias/images/archive.png'
import download from '../../../../images/download.png'

const SegundaViaBoleto = (props) => {
    const [loading, setLoading] = useState(false)
    const [didError, setDidError] = useState(false)
    const [errors, setErrors] = useState([])
    const [cpf, setCpf] = useState("")
    const [boletos, setBoletos] = useState([])
    const [noData, setNodata] = useState(false)


    useEffect(() => {
        window.parent.postMessage('change', window.location.origin)
    });

    const validateForm = () => {
        const errors = []
        if (cpf.length === 0) {
            errors.push({ field: 'cpf', message: 'Preencha seu CPF' })
        }
        else {
            if (cpf.length !== 11) {
                errors.push({ field: "cpf", message: "Verifique seu CPF" })
            }
        }
        setErrors(errors)
        return errors.length
    }

    const onSendForm = async () => {
        setNodata(false)
        if (validateForm()) {
            return
        }
        setLoading(true)
        const res = await BoletoService.getBoleto(cpf)
        setLoading(false)
        if (res.status) {
            if (!res.familias.length) {
                setNodata(true)
            }
            setBoletos(res.familias)
        }
        if (res.info === "Dados enviados invalidos") {
            errors.push({ field: "form", message: "Beneficiário não encontrado" })
        }
        if (res.error) {
            setDidError(true)
        }
        setErrors(errors)
        window.parent.postMessage('change', window.location.origin)
    }


    const renderValidation = (field) => {
        const error = errors.find(e => e.field === field)
        if (!error) {
            return null
        }
        return (<div className="validation-message">{error.message}</div>)
    }

    const renderError = () => {
        if (didError) {
            return (
                <div className="not-found-wrapper">
                    <img src={error} alt="Erro" />
                    <h5>Ocorreu um erro</h5>
                    <p>
                        Um erro ocorreu ao processar sua consulta. Por favor tente
                        novamente.
                    </p>
                    <p>
                        Se esta mensagem for recorrente, entre em contato com o suporte.
                    </p>
                </div>
            );
        }
        return null;
    };

    const renderNoData = () => {
        if (noData) {
            return (
                <div className="not-found-wrapper">
                    <p>
                        Nenhum boleto encontrado para esse CPF.
                    </p>
                </div>
            )
        }
        return null
    }

    const renderData = () => {
        if (boletos.length) {
            return (
                <div className="table-wrapper mgv-4">

                    <table>
                        <thead>
                            <tr>
                                <th>Contrato</th>
                                <th>Titular do Plano</th>
                                <th>Data de Emissão</th>
                                <th>Número</th>
                                <th>Status</th>
                                <th>Valor</th>
                                <th>Vencimento</th>
                                <th>Visualizar</th>
                            </tr>
                        </thead>
                        <tbody>
                            {boletos.map((familia, index) => {
                                return (
                                    familia.BOLETOS.map((boleto) => {
                                        return (<tr key={index}>
                                            <td>{familia.CONTRATO}</td>
                                            <td>{familia.TITULAR}</td>
                                            <td>{boleto.DATAEMISSAO}</td>
                                            <td>{boleto.NUMERO}</td>
                                            <td>{boleto.STATUS}</td>
                                            <td>{boleto.VALOR}</td>
                                            <td>{boleto.VENCIMENTO}</td>
                                            <td>
                                                <a href={`${config.URL_BASE_PORTAL}segunda-via/${boleto.RECNO}`} target="_blank" rel="noopener noreferrer">
                                                    <img src={download} alt='download' />
                                                </a>
                                            </td>
                                        </tr>)
                                    })
                                )
                            })}
                        </tbody>
                    </table>
                </div>
            )
        }
    }

    const renderLoading = () => {
        if (loading) {
            return <div className="lds-ring"><div></div><div></div><div></div><div></div></div>
        }
    }

    return (
        <section className={`consulta-copart txt8 lh-1 ${props.hide ? 'hide' : ''}`}>
            <h2 className="txt-laranja">2ª via de boleto</h2>
            {/* Agora você pode consultar o valor de coparticipação para consultas, exames e terapias (fisioterapia, fonoaudiologia, psicologia e nutrição) através do site.
					<br/><br/>
					Para realizar a consulta, basta preencher o número da carteira do beneficiário e a data de nascimento.
					Você pode localizar o procedimento filtrando por especialidade ou palavra-chave, após selecione o procedimento clicando sobre o mesmo.
					<br/><br/>
					Para procedimentos médicos, cirúrgicos ou internações, entre em contato através do 0800 642 1800 ou pessoalmente em um dos nossos postos de atendimento.
					 */}
            <h3 className="txt-verde">Informe os campos abaixo</h3>
            <div className="box-passos">

                <div className="linha-form--small">
                    <span>CPF <span className="txt-vermelho">*</span></span>
                    <Cleave type={'ontouchstart' in document.documentElement ? "tel" : "text"} options={{ blocks: [3, 3, 3, 2], delimiters: ['.', '.', '-'], numericOnly: true }} onChange={e => setCpf(e.target.rawValue)} />
                    <button className="btn" onClick={() => onSendForm()} >Buscar</button>
                    {renderValidation("cpf")}
                </div>
                {renderLoading()}
                {renderValidation('form')}
                {renderError()}
                {renderData()}
                {renderNoData()}
            </div>
        </section>
    )
};

export default SegundaViaBoleto;